import { Component, HostListener, inject, Input, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { NavigationItem } from '../../interfaces/navigation-item';
import { CommonModule } from '@angular/common';
import { MatDivider } from '@angular/material/divider'
import { Router } from '@angular/router';

@Component({
  selector: 'isto-menu',
  imports: [
    CommonModule,
    MatDivider
  ],
  templateUrl: './menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {
  #router = inject(Router);

  @Input()
  menuItems: NavigationItem[] = [];

  showMenuDrawer = signal(false);
  selectedMenuItem = signal<NavigationItem>({});

  private menuClicked: boolean = false;

  ngOnInit(): void {
  }

  menuItemClick(item: NavigationItem, event: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.menuClicked = true;
    if (this.selectedMenuItem()) {
      if (this.selectedMenuItem() === item) {
        this.closeMenu();
      } else {
        this.selectedMenuItem.set(item);
        this.showMenuDrawer.set(true);
      }
    } else {
      this.showMenuDrawer.set(true);
      this.selectedMenuItem.set(item)
    }
  }

  navigate(item: NavigationItem, event: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    if (item.route) {
      if(item.external) {        
        this.closeMenu();
        window.open(item.route, '_blank');
      } else {
        this.closeMenu();
        this.#router.navigateByUrl(item.route);
      }
      //this.#router.navigateByUrl(item.route);
    }
  }

  @HostListener('document:click')
  outsideClick(): void {
    if (!this.menuClicked) {
      this.closeMenu();
    }
    this.menuClicked = false;
  }

  closeMenu(): void {
    this.showMenuDrawer.set(false);
    this.selectedMenuItem.set({});
  }
}
